import React from 'react';

const AnnouncementItem = () => {
    <>
    AnnouncementItem
    </>
}

export default AnnouncementItem